
import ParcelPlaceholder from "@/components/Parcel/ParcelPlaceholder.vue";
import { formatFloat, propsInstance } from "@/lib/util";
import { getCropIntervalStr } from "../../lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { Parcel } from "@/lib/types/Parcel";

interface ParcelItemProps {
  parcel: Parcel;
  date?: string;
  inverted?: boolean;
  topProp?: keyof ComputedParcelProps;
  bottomProp?: keyof ComputedParcelProps;
  rightProp?: keyof ComputedParcelProps;
  navigable?: boolean;
}

const Props = propsInstance<ParcelItemProps>({
  parcel: {
    type: Object,
    required: true,
  },
  date: {
    type: String,
    required: false,
  },
  inverted: {
    type: Boolean,
    required: false,
    default: false,
  },
  topProp: {
    type: String as any,
    required: false,
    default: "crop",
  },
  bottomProp: {
    type: String as any,
    required: false,
    default: "interval",
  },
  rightProp: {
    type: String as any,
    required: false,
    default: "area",
  },
  navigable: {
    type: Boolean,
    required: false,
    default: false,
  },
});

@Component({
  name: "ParcelItem",
  components: { ParcelPlaceholder },
})
export default class ParcelItem extends mixins(MixedVue, Props) {
  get availableProps(): ComputedParcelProps {
    const parcelSeason = this.$store.getters.seasons[this.parcel.season];
    const interval = this.getCropInterval(this.parcel.crop_intervals, this.date, parcelSeason);
    return {
      empty: "",
      interval: getCropIntervalStr(interval, parcelSeason, this.$language.current),
      crop: this.getParcelCropName(this.parcel, this.date),
      name: this.parcel.name,
      locality: this.parcel.locality,
      reference: this.parcel.reference,
      area: formatFloat(this.parcel.hectares, 1) + " ha",
    };
  }
}

interface ComputedParcelProps {
  empty: string;
  interval: string;
  crop: string;
  name: string;
  locality: string;
  reference: string;
  area: string;
}
